module.exports = __webpack_public_path__ + "media/images/tower-e7e248895deba1f03d1939ebb4916faf.svg";